import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

const classnames = (...classes: any[]) => twMerge(clsx(...classes));

export default classnames;
